import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import SelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField';
import { ArtsAndCraftsDeviationFieldName } from '../../types';

/* TODO: Replace with actual categories fetched from the API */
const PLACEHOLDER_CATEGORIES = [
  { value: 'painting', label: 'Painting' },
  { value: 'sculpture', label: 'Sculpture' },
  { value: 'jewelry', label: 'Jewelry' },
  { value: 'ceramics', label: 'Ceramics' },
  { value: 'textile', label: 'Textile' },
  { value: 'woodwork', label: 'Woodwork' },
  { value: 'glasswork', label: 'Glasswork' },
  { value: 'printmaking', label: 'Printmaking' },
  { value: 'other', label: 'Other' },
];

const CategoryField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control, formState } = useFormContext();
  const { field } = useController({
    name: ArtsAndCraftsDeviationFieldName.CATEGORY,
    control,
  });
  const error = formState.errors[ArtsAndCraftsDeviationFieldName.CATEGORY];

  return (
    <SelectField
      id={id}
      label={t('artsAndCraftsDeviationPopup.form.category.label')}
      placeholder={t('artsAndCraftsDeviationPopup.form.category.placeholder')}
      items={PLACEHOLDER_CATEGORIES}
      value={field.value}
      onSelect={field.onChange}
      error={error?.message as string | undefined}
      isRequired
      noBottomSpacing
    />
  );
};
CategoryField.displayName = 'CategoryField';

export default CategoryField;
